import React, { ChangeEvent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  memberDetailActions,
  selectConnectCommunityUserTypeLoading,
} from 'features/member/reducer/memberDetailSlice';

import { CommonSpinner } from '../common';
import StatusDropdown from 'components/memberdetail/detail/connect/connectinformation/StatusDropdown';

import { connectCommunityUserTypeOption } from 'constants/member/connect';
import { ConnectCommunityUserType } from 'types/member';

import * as S from './CommunityUserType.styled';

interface Props {
  userId: string;
  communityUserType: ConnectCommunityUserType;
}

const CommunityUserType = ({ userId, communityUserType }: Props) => {
  const dispatch = useDispatch();
  const communityUserTypeLoading = useSelector(selectConnectCommunityUserTypeLoading);

  const [currentCommunityUserType, setCurrentCommunityUserType] =
    useState<number>(communityUserType);

  const onChangeCommunityUserType = ({
    target: { value },
  }: ChangeEvent<{ name?: string; value: unknown }>): void => {
    setCurrentCommunityUserType(Number(value));
    dispatch(
      memberDetailActions.updateCommunityUserType({
        userId,
        type: Number(value),
      }),
    );
  };

  return (
    <S.CommunityUserTypeWrapper>
      <StatusDropdown
        optionList={connectCommunityUserTypeOption}
        currentValue={currentCommunityUserType}
        onChangeValue={onChangeCommunityUserType}
      />
      {communityUserTypeLoading && <CommonSpinner />}
    </S.CommunityUserTypeWrapper>
  );
};

export default CommunityUserType;
